import React from 'react';
import * as Types from '../types';
import Text from '../../Typography/Text';
import { BankPartners, BankPartnersLink, FinancialInstitution, FlexPay, StateLicensesAndDBAs, StateLicensesFlexPay } from './content';
const {
  ALL_PRODUCTS,
  AUTO_FINANCE,
  AUTO_REFINANCE,
  BUY_NOW_PAY_LATER,
  HOME_IMPROVEMENT_CREDIT_LINE,
  LENDING_TREE,
  PERSONAL_CREDIT_LINE,
  PERSONAL_LOAN,
  REWARDS_CHECKING
} = Types;
const AllProducts = ({
  publicSiteUrl
}) => /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, "All loans, Personal Credit Lines, and checking and savings accounts are provided by Upgrade's", ' ', /*#__PURE__*/React.createElement(BankPartnersLink, {
  publicSiteUrl
}), ". Upgrade Visa\xAE Cards and Upgrade Visa\xAE Debit Cards are issued by Upgrade's ", /*#__PURE__*/React.createElement(BankPartnersLink, {
  publicSiteUrl
}), ", pursuant to a license from Visa USA Inc.", ' ', /*#__PURE__*/React.createElement(StateLicensesAndDBAs, null), " ", /*#__PURE__*/React.createElement(FinancialInstitution, null));
const AutoFinance = () => /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, "Dealerships in Upgrade's network can assign retail installment sale contracts to Upgrade.", ' ', /*#__PURE__*/React.createElement(StateLicensesAndDBAs, null), " ", /*#__PURE__*/React.createElement(FinancialInstitution, null));
const AutoRefinance = ({
  publicSiteUrl = '',
  withAutoRefinance
}) => /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, /*#__PURE__*/React.createElement(BankPartners, {
  publicSiteUrl,
  withAutoRefinance
}), " ", /*#__PURE__*/React.createElement(StateLicensesAndDBAs, null), " ", /*#__PURE__*/React.createElement(FinancialInstitution, null));
const LendingTreeCredit = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, "Personal Credit Lines are issued by Cross River Bank, Member FDIC. The Upgrade Card associated with a Personal Credit Line is issued by Sutton Bank, Member FDIC, or Cross River Bank, Member FDIC, pursuant to licenses from Visa U.S.A. Inc. The LendingTree Win Card is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc. Upgrade is the servicer of the Win Card with Personal Credit Line."), /*#__PURE__*/React.createElement(StateLicensesAndDBAs, null), /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, /*#__PURE__*/React.createElement(FinancialInstitution, {
  href: "https://link.upgrade.com/f/a/iCK5pWub54X45jGt9-kNAA~~/AAQRxQA~/RgRm0hVpP0ROaHR0cHM6Ly91cGdyYWRlLnplbmRlc2suY29tL2hjL2VuLXVzL2FydGljbGVzLzExNTAwNTIwMjQwNy0tSXMtVXBncmFkZS1hLWJhbmstVwNzcGNCCmTnaZDvZLFksVpSFHNkYW5nZWxvQHVwZ3JhZGUuY29tWAQAAAIV"
})));
const FlexPayProduct = ({
  publicSiteUrl
}) => /*#__PURE__*/React.createElement(Text, {
  as: "p",
  size: "sm"
}, /*#__PURE__*/React.createElement(FlexPay, {
  publicSiteUrl
}), " ", /*#__PURE__*/React.createElement(StateLicensesFlexPay, {
  publicSiteUrl
}), " ", /*#__PURE__*/React.createElement(StateLicensesAndDBAs, null), ' ', /*#__PURE__*/React.createElement(FinancialInstitution, null));
const BankNoticeV2 = ({
  type,
  publicSiteUrl,
  withAutoRefinance,
  rewardProgramCode,
  programDefinitionCode: programDefinitionCodeProp,
  cardIssuingBanks
}) => {
  const programDefinitionCode = programDefinitionCodeProp || rewardProgramCode;
  switch (type) {
    case LENDING_TREE:
      return /*#__PURE__*/React.createElement(LendingTreeCredit, null);
    case ALL_PRODUCTS:
    case PERSONAL_LOAN:
    case PERSONAL_CREDIT_LINE:
    case REWARDS_CHECKING:
    case HOME_IMPROVEMENT_CREDIT_LINE:
      return /*#__PURE__*/React.createElement(AllProducts, {
        withAutoRefinance,
        publicSiteUrl,
        programDefinitionCode,
        cardIssuingBanks
      });
    case AUTO_REFINANCE:
      return /*#__PURE__*/React.createElement(AutoRefinance, {
        withAutoRefinance,
        publicSiteUrl
      });
    case AUTO_FINANCE:
      return /*#__PURE__*/React.createElement(AutoFinance, {
        publicSiteUrl
      });
    case BUY_NOW_PAY_LATER:
      return /*#__PURE__*/React.createElement(FlexPayProduct, {
        publicSiteUrl
      });
    default:
      return null;
  }
};
export default BankNoticeV2;
//# sourceMappingURL=index.js.map